import { makeStyles } from '@material-ui/styles'
import GlobalDropdownWithSearch from 'core/elements/dropdown/GlobalDropdownWithSearch'
import React from 'react'

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'grid',
    gridAutoFlow: 'column',
    gridTemplateColumns: 'auto',
    alignItems: 'flex-end',
    gap: theme.spacing(1),
  },
  filterDropdown: {
    width: 150,
    minWidth: 100,
    maxWidth: 200,
  },
}))

export interface FilterOption {
  value: string
  label: string
}

export interface FilterConfig {
  /** Unique key for this filter (used in API params) */
  key: string
  /** Display label for the filter */
  label: string
  /** Available options for this filter */
  options: FilterOption[]
  /** Default value (usually 'all') */
  defaultValue?: string
}

export interface ServerSideFiltersProps {
  /** Filter configurations */
  filters: FilterConfig[]
  /** Current filter values */
  values: Record<string, string>
  /** Callback when a filter value changes */
  onChange: (key: string, value: string) => void
  /** Disabled state */
  disabled?: boolean
}

/**
 * Generic server-side filters component.
 *
 * Renders a row of dropdown filters based on the provided configuration.
 * Each filter has a key that maps to an API query parameter.
 */
export const ServerSideFilters: React.FC<ServerSideFiltersProps> = ({
  filters,
  values,
  onChange,
  disabled = false,
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {filters.map((filter) => (
        <React.Fragment key={filter.key}>
          <GlobalDropdownWithSearch
            label={filter.label}
            items={filter.options}
            onChange={(item) => onChange(filter.key, item.value)}
            value={values[filter.key] ?? filter.defaultValue ?? 'all'}
            showLabelOnTop
            align="left"
            disabled={disabled}
          />
        </React.Fragment>
      ))}
    </div>
  )
}

export default ServerSideFilters
